import React from 'react';

import Skeleton from '@atlaskit/avatar/skeleton';

const AvatarSkeletonSquareExample = (): React.JSX.Element => {
	return <Skeleton appearance="square" />;
};

export default AvatarSkeletonSquareExample;
